import type { ComponentProps, ReactNode } from 'react'
import { IntlProvider } from 'react-intl'

import { useLocale } from '../contexts/LocaleContext'
import { messages } from './index'

const DEFAULT_MESSAGES = messages['fr-FR']

type IntlLocaleProviderProps = {
  children: ReactNode
}

export const IntlLocaleProvider = ({ children }: IntlLocaleProviderProps): JSX.Element => {
  const { locale } = useLocale()
  return (
    <IntlProvider
      locale={locale}
      messages={messages[locale] ?? DEFAULT_MESSAGES}
      children={children as ComponentProps<typeof IntlProvider>['children']}
    />
  )
}
